import clsx from 'clsx';
import { HTMLAttributes } from 'react';

export interface FormLabelProps extends HTMLAttributes<HTMLSpanElement> {
  required?: boolean;
}

const DEFAULT_CLASS_NAME = 'inline-flex font-bold text-sm text-stone-500';

export function FormLabel({
  children,
  className,
  required,
  ...rest
}: FormLabelProps) {
  return (
    <label className={clsx(DEFAULT_CLASS_NAME, className)} {...rest}>
      {children}
      {required && <span className="text-red-500 ms-0.5">*</span>}
    </label>
  );
}

export default FormLabel;
